// extracted by mini-css-extract-plugin
export var item = "OfferItem-module--item--o8U1o";
export var itemEnabled = "OfferItem-module--itemEnabled--c8fnS";
export var itemDisabled = "OfferItem-module--itemDisabled--VALex";